(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
var fullVideo = new Boulies.PopupModal({
    container: '.bt31-fvContainer',
    background: '.bt31-fvBg',
    content: '.bt31-fvContent',
    openBTN: '.bt31-fvOpen',
    closeBTN: '.bt31-fvClose',
    beforeClose: function(){
        document.querySelector('#bt31-fullCollectionVideo').pause();
    }
})
fullVideo.initModal();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customize--featured-reviews"] && !Shopify.designMode) return;
  try {
    
  $('.b5-featured-reviews-list').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    centerMode: true,
    variableWidth: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customize--press-reviews"] && !Shopify.designMode) return;
  try {
    
  $('.press-reviews__list').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          dots: true,
          slidesToShow: 1,
        },
      },
    ],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  var noti_bar = document.querySelector('.top-notify');
  if (noti_bar) {
    if (document.querySelector('.bt5-header').classList.contains('product')) {
      var new_noti_bar = noti_bar.cloneNode(true);
      document.querySelector('.header-notify-bar-wrap').removeChild(noti_bar);
      document.querySelector('.product-notify-bar-wrap').appendChild(new_noti_bar);
      new_noti_bar.style.display = 'flex';
      new_noti_bar.querySelector('.top-notify__close-btn').addEventListener('click', function () {
        new_noti_bar.style.display = 'none';
      });
    } else {
      noti_bar.style.display = 'flex';
      noti_bar.querySelector('.top-notify__close-btn').addEventListener('click', function () {
        noti_bar.style.display = 'none';
      });
    }
  }

  (function () {
    var desktopProductsMenu = document.querySelector('.bt5-products-menu');
    var defaultTabKey = 'gaming';
    var initialActiveTab = desktopProductsMenu
      ? desktopProductsMenu.querySelector('[data-products-menu-tab].is-active')
      : null;
    var initialTabKey = initialActiveTab ? initialActiveTab.getAttribute('data-products-menu-tab') : defaultTabKey;
    var tabs;
    var panels;

    if (!desktopProductsMenu || desktopProductsMenu.dataset.desktopProductsMenuReady === 'true') {
      return;
    }

    tabs = Array.prototype.slice.call(desktopProductsMenu.querySelectorAll('[data-products-menu-tab]'));
    panels = Array.prototype.slice.call(desktopProductsMenu.querySelectorAll('[data-products-menu-panel]'));

    if (!tabs.length || !panels.length) {
      return;
    }

    desktopProductsMenu.dataset.desktopProductsMenuReady = 'true';

    function setActiveProductsTab(tabKey) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-products-menu-tab') === tabKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-products-menu-panel') === tabKey;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    tabs.forEach(function (tab) {
      var tabKey = tab.getAttribute('data-products-menu-tab');
      tab.setAttribute('aria-pressed', tabKey === initialTabKey ? 'true' : 'false');
      tab.addEventListener('mouseenter', function () {
        setActiveProductsTab(tabKey);
      });
      tab.addEventListener('focus', function () {
        setActiveProductsTab(tabKey);
      });
    });

    setActiveProductsTab(initialTabKey);
  })();

  (function () {
    var sliderMenu = document.querySelector('.bt5-slider-menu');
    var drawer = document.querySelector('.header-mobile-drawer');
    var closeTrigger = sliderMenu ? sliderMenu.querySelector('.js-slider-close-trigger') : null;
    var accordion = drawer ? drawer.querySelector('[data-drawer-accordion]') : null;
    var drawerStateStorageKey = 'bt5-mobile-drawer-state';
    if (!sliderMenu || !drawer || drawer.dataset.mobileDrawerReady === 'true') {
      return;
    }

    drawer.dataset.mobileDrawerReady = 'true';

    // Close the drawer when users tap the overlay outside the panel.
    sliderMenu.addEventListener('click', function (event) {
      if (!drawer.contains(event.target) && closeTrigger) {
        closeTrigger.click();
      }
    });

    // Clear any in-flight height transition before starting a new one.
    function clearPanelAnimation(panel) {
      if (!panel || !panel._drawerTransitionHandler) {
        return;
      }

      panel.removeEventListener('transitionend', panel._drawerTransitionHandler);
      panel._drawerTransitionHandler = null;
    }

    function syncPanelState(panel, expanded) {
      if (!panel) {
        return;
      }

      clearPanelAnimation(panel);
      panel.dataset.expanded = expanded ? 'true' : 'false';
      panel.hidden = !expanded;
      panel.style.maxHeight = expanded ? 'none' : '';
      panel.style.overflow = '';
    }

    function animatePanel(panel, expanded) {
      var startHeight;
      var targetHeight;

      if (!panel) {
        return;
      }

      clearPanelAnimation(panel);

      if (expanded) {
        startHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height;
        panel.hidden = false;
        panel.style.overflow = 'hidden';
        panel.style.maxHeight = startHeight + 'px';
        panel.dataset.expanded = 'true';
        targetHeight = panel.scrollHeight;
        void panel.offsetHeight;
        panel.style.maxHeight = targetHeight + 'px';
        panel._drawerTransitionHandler = function (event) {
          if (event.target !== panel || event.propertyName !== 'max-height') {
            return;
          }

          clearPanelAnimation(panel);
          panel.style.maxHeight = 'none';
          panel.style.overflow = '';
        };
        panel.addEventListener('transitionend', panel._drawerTransitionHandler);
        return;
      }

      if (panel.hidden) {
        syncPanelState(panel, false);
        return;
      }

      startHeight = panel.getBoundingClientRect().height;
      panel.style.overflow = 'hidden';
      panel.style.maxHeight = startHeight + 'px';
      void panel.offsetHeight;
      panel.dataset.expanded = 'false';
      panel.style.maxHeight = '0px';
      panel._drawerTransitionHandler = function (event) {
        if (event.target !== panel || event.propertyName !== 'max-height') {
          return;
        }

        clearPanelAnimation(panel);
        panel.hidden = true;
        panel.style.maxHeight = '';
        panel.style.overflow = '';
      };
      panel.addEventListener('transitionend', panel._drawerTransitionHandler);
    }

    function setSectionState(trigger, expanded) {
      var group = trigger.closest('[data-drawer-group]');
      var panel = group ? group.querySelector('[data-drawer-section-panel]') : null;

      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      if (panel) {
        animatePanel(panel, expanded);
      }
    }

    function setCategoryState(item, expanded) {
      var trigger = item ? item.querySelector('[data-drawer-category-trigger]') : null;
      var panel = item ? item.querySelector('[data-drawer-category-panel]') : null;

      if (!trigger || !panel) {
        return;
      }

      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      animatePanel(panel, expanded);
    }

    function readDrawerState() {
      var rawState;

      try {
        rawState = window.sessionStorage.getItem(drawerStateStorageKey);
      } catch (error) {
        return null;
      }

      if (!rawState) {
        return null;
      }

      try {
        return JSON.parse(rawState);
      } catch (error) {
        return null;
      }
    }

    // Keep the current accordion state for this browser session.
    function persistDrawerState() {
      var state = {
        sections: {},
        openCategory: null,
      };
      var groups = drawer.querySelectorAll('[data-drawer-group]');
      var categoryItems;
      var group;
      var trigger;
      var item;
      var sectionId;
      var categoryId;

      for (var index = 0; index < groups.length; index++) {
        group = groups[index];
        trigger = group.querySelector('[data-drawer-section-trigger]');
        sectionId = group.getAttribute('data-drawer-section-id');

        if (trigger && sectionId) {
          state.sections[sectionId] = trigger.getAttribute('aria-expanded') === 'true';
        }
      }

      if (accordion) {
        categoryItems = accordion.querySelectorAll('[data-drawer-category]');

        for (var itemIndex = 0; itemIndex < categoryItems.length; itemIndex++) {
          item = categoryItems[itemIndex];
          trigger = item.querySelector('[data-drawer-category-trigger]');
          categoryId = item.getAttribute('data-drawer-category-id');

          if (trigger && categoryId && trigger.getAttribute('aria-expanded') === 'true') {
            state.openCategory = categoryId;
            break;
          }
        }
      }

      try {
        window.sessionStorage.setItem(drawerStateStorageKey, JSON.stringify(state));
      } catch (error) {}
    }

    function restoreDrawerState() {
      var state = readDrawerState();
      var groups;
      var categoryItems;
      var group;
      var trigger;
      var item;
      var sectionId;
      var categoryId;
      var hasMatchedCategory = false;

      if (!state) {
        return;
      }

      groups = drawer.querySelectorAll('[data-drawer-group]');

      for (var groupIndex = 0; groupIndex < groups.length; groupIndex++) {
        group = groups[groupIndex];
        trigger = group.querySelector('[data-drawer-section-trigger]');
        sectionId = group.getAttribute('data-drawer-section-id');

        if (trigger && sectionId && state.sections && Object.prototype.hasOwnProperty.call(state.sections, sectionId)) {
          trigger.setAttribute('aria-expanded', state.sections[sectionId] ? 'true' : 'false');
        }
      }

      if (!accordion || !Object.prototype.hasOwnProperty.call(state, 'openCategory')) {
        return;
      }

      categoryItems = accordion.querySelectorAll('[data-drawer-category]');

      if (state.openCategory) {
        for (var itemIndex = 0; itemIndex < categoryItems.length; itemIndex++) {
          item = categoryItems[itemIndex];
          categoryId = item.getAttribute('data-drawer-category-id');

          if (categoryId === state.openCategory) {
            hasMatchedCategory = true;
            break;
          }
        }

        if (!hasMatchedCategory) {
          return;
        }
      }

      for (var categoryIndex = 0; categoryIndex < categoryItems.length; categoryIndex++) {
        item = categoryItems[categoryIndex];
        trigger = item.querySelector('[data-drawer-category-trigger]');
        categoryId = item.getAttribute('data-drawer-category-id');

        if (trigger && categoryId) {
          trigger.setAttribute('aria-expanded', categoryId === state.openCategory ? 'true' : 'false');
        }
      }
    }

    // Restore the saved state before wiring up the click handlers.
    restoreDrawerState();

    function initSectionTrigger(trigger) {
      var group = trigger.closest('[data-drawer-group]');
      var panel = group ? group.querySelector('[data-drawer-section-panel]') : null;

      syncPanelState(panel, trigger.getAttribute('aria-expanded') === 'true');

      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        setSectionState(trigger, !expanded);
        persistDrawerState();
      });
    }

    var sectionTriggers = drawer.querySelectorAll('[data-drawer-section-trigger]');
    for (var i = 0; i < sectionTriggers.length; i++) {
      initSectionTrigger(sectionTriggers[i]);
    }

    if (!accordion) {
      return;
    }

    function initCategoryTrigger(trigger) {
      var item = trigger.closest('[data-drawer-category]');
      var panel = item ? item.querySelector('[data-drawer-category-panel]') : null;

      syncPanelState(panel, trigger.getAttribute('aria-expanded') === 'true');

      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-drawer-category]');
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var categoryItems = accordion.querySelectorAll('[data-drawer-category]');

        for (var k = 0; k < categoryItems.length; k++) {
          var otherItem = categoryItems[k];
          if (otherItem !== item) {
            setCategoryState(otherItem, false);
          }
        }

        setCategoryState(item, !expanded);
        persistDrawerState();
      });
    }

    var categoryTriggers = accordion.querySelectorAll('[data-drawer-category-trigger]');
    for (var j = 0; j < categoryTriggers.length; j++) {
      initCategoryTrigger(categoryTriggers[j]);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
